import { rootApi } from '../rootApi';
import { setUserParams } from '../../store/slices/userParamsSlice';

export const userApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserGroups: builder.query({
            query: () => ({
                url: 'v1/user/getuserdropdown',
                method: 'GET'
            })
        }),

        getUserByDealerDropdown: builder.query({
            query: () => ({
                url: 'v1/user/GetUserByDealerDropdown',
                method: 'GET'
            })
        }),
        getUserParams: builder.query({
            query: () => ({
                url: 'v1/user/GetUserParams',
                method: 'GET'
            }),
            transformResponse: (response) => {
                const data = response?.data;
                if (!data || typeof data !== 'object') return data;
                // Bazı API yanıtlarında PascalCase gelebilir; Redux’ta isDomestic kullanılıyor
                if (data.isDomestic === undefined && data.IsDomestic !== undefined) {
                    return { ...data, isDomestic: data.IsDomestic };
                }
                return data;
            },
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(setUserParams(data));
                } catch (error) {
                    console.error('Failed to fetch user params:', error);
                }
            },
            providesTags: ['UserParams']
        })
    })
});

export const { useGetUserGroupsQuery, useGetUserByDealerDropdownQuery, useGetUserParamsQuery } = userApi;
